module.exports = __webpack_public_path__ + "assets/img/18_1779.405fbb60.jpg";